export const GIFT_AID_PLUS_VALUE_PERCENTAGE = 0.25;
